// extracted by mini-css-extract-plugin
export var size = "q_cH";
export var shoe = "q_cJ";
export var title = "q_bq";
export var table = "q_cK";
export var desc = "q_cL";